/* tslint:disable */

/* eslint-disable */

/**
 * API Gateway Backstage Plugin
 * Backstage plugins api spec
 *
 * The version of the OpenAPI document: v1
 * Contact: sarkan.mo@tomtom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import type { Link } from './Link';
import { LinkFromJSON, LinkToJSON } from './Link';
import type { Product } from './Product';
import { ProductFromJSON, ProductToJSON } from './Product';
import type { Target } from './Target';
import { TargetFromJSON, TargetToJSON } from './Target';

/**
 *
 * @export
 * @interface Proxy
 */
export interface Proxy {
  /**
   * The unique name of the proxy configuration.
   * @type {string}
   * @memberof Proxy
   */
  name?: string;
  /**
   * The owner or team responsible for the proxy.
   * @type {string}
   * @memberof Proxy
   */
  owner?: string;
  /**
   * A list of tags for categorization.
   * @type {Array<string>}
   * @memberof Proxy
   */
  tags?: Array<string>;
  /**
   * The gateway this proxy is associated with.
   * @type {string}
   * @memberof Proxy
   */
  gateway?: string;
  /**
   *
   * @type {Array<Link>}
   * @memberof Proxy
   */
  links?: Array<Link>;
  /**
   * The state of the proxy.
   * @type {string}
   * @memberof Proxy
   */
  state?: ProxyStateEnum;
  /**
   *
   * @type {Array<Product>}
   * @memberof Proxy
   */
  products?: Array<Product>;
  /**
   *
   * @type {Array<Target>}
   * @memberof Proxy
   */
  targets?: Array<Target>;
}

/**
 * @export
 */
export const ProxyStateEnum = {
  Synced: 'synced',
  DriftDetected: 'drift_detected',
  WaitingForReview: 'waiting_for_review',
} as const;
export type ProxyStateEnum =
  (typeof ProxyStateEnum)[keyof typeof ProxyStateEnum];

/**
 * Check if a given object implements the Proxy interface.
 */
// @ts-ignore
export function instanceOfProxy(value: object): value is Proxy {
  return true;
}

export function ProxyFromJSON(json: any): Proxy {
  return ProxyFromJSONTyped(json, false);
}

export function ProxyFromJSONTyped(
  json: any,
  // @ts-ignore
  ignoreDiscriminator: boolean,
): Proxy {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'] == null ? undefined : json['name'],
    owner: json['owner'] == null ? undefined : json['owner'],
    tags: json['tags'] == null ? undefined : json['tags'],
    gateway: json['gateway'] == null ? undefined : json['gateway'],
    links:
      json['links'] == null
        ? undefined
        : (json['links'] as Array<any>).map(LinkFromJSON),
    state: json['state'] == null ? undefined : json['state'],
    products:
      json['products'] == null
        ? undefined
        : (json['products'] as Array<any>).map(ProductFromJSON),
    targets:
      json['targets'] == null
        ? undefined
        : (json['targets'] as Array<any>).map(TargetFromJSON),
  };
}

export function ProxyToJSON(json: any): Proxy {
  return ProxyToJSONTyped(json, false);
}

export function ProxyToJSONTyped(
  value?: Proxy | null,
  // @ts-ignore
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value['name'],
    owner: value['owner'],
    tags: value['tags'],
    gateway: value['gateway'],
    links:
      value['links'] == null
        ? undefined
        : (value['links'] as Array<any>).map(LinkToJSON),
    state: value['state'],
    products:
      value['products'] == null
        ? undefined
        : (value['products'] as Array<any>).map(ProductToJSON),
    targets:
      value['targets'] == null
        ? undefined
        : (value['targets'] as Array<any>).map(TargetToJSON),
  };
}
